<div class="leave-application-list-container">
  <table mat-table [dataSource]="leaveApplicationDataSource">

    <!-- Position Column -->

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data złożenia wniosku </th>
      <td mat-cell *matCellDef="let element">
        <a></a>
        <a class="default-link" [routerLink]="['/kadry/wnioski-urlopowe/szczegoly', element.uuid]">{{element.createdAt | date:'y-MM-dd'}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="acceptanceAt">
      <th mat-header-cell *matHeaderCellDef> Data akceptacji wniosku </th>
      <td mat-cell *matCellDef="let element">
        {{element.acceptanceAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Rodzaj wniosku</th>
      <td mat-cell *matCellDef="let element">
        {{element.type?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status</th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>


    <ng-container matColumnDef="start">
      <th mat-header-cell *matHeaderCellDef> Termin urlopu  </th>
      <td mat-cell *matCellDef="let element">
        {{element.startDate | date:'y-MM-dd'}}/{{element.endDate | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="day">
      <th mat-header-cell *matHeaderCellDef> Liczba dni urlopu   </th>
      <td mat-cell *matCellDef="let element">
    {{element.time?  '-' : element.day}}
      </td>
    </ng-container>

    <ng-container matColumnDef="time">
      <th mat-header-cell *matHeaderCellDef> Wymiar godzin   </th>
      <td mat-cell *matCellDef="let element">
        {{element.time?  element.time.name : '-'}}
      </td>
    </ng-container>



    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
<!--        <button (click)="openDocument(element)"-->
<!--                mat-icon-button color="primary"><mat-icon>visibility</mat-icon></button>-->
<!--        <button mat-icon-button color="accent" aria-label="" (click)="downloadFile(element.uuid)">-->
<!--          <mat-icon>download</mat-icon>-->
<!--        </button>-->
        <button [disabled]="!(userPermissions | async).human_resources.write"  mat-icon-button color="accent" (click)="downloadPdf(element)">  <mat-icon>download</mat-icon></button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
</div>
